export default function useCopyText(textToCopy: string) {
	function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
		event.stopPropagation();
		navigator.clipboard.writeText(textToCopy);
	}

	return { handleClick };
}
